module.exports = __webpack_public_path__ + "static/media/12.1.6eb758c8.png";